import React, { useState } from 'react';

const API_URL = 'https://www.zonezapp.com/auth';
const APP_KEY = 'zonezapp-mobile-app'; // Use the same app key as mobile app

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, appKey: APP_KEY })
      });
      const data = await res.json();
      if (res.ok && data.access_token) {
        localStorage.setItem('zz_token', data.access_token);
        // If backend returns a location object, persist it for the post-login home screen
        if (data.location) {
          try { localStorage.setItem('zz_location', JSON.stringify(data.location)); } catch(_) { localStorage.setItem('zz_location', data.location); }
        }
        // Redirect to new post-login home (replaces map landing)
        window.location.href = '/webapp/home';
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (err) {
      setError('Network error');
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 400, margin: '40px auto', padding: 24, border: '1px solid #eee', borderRadius: 8 }}>
      <h2>ZoneZapp Web App Login</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label>Email</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required style={{ width: '100%', padding: 8 }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required style={{ width: '100%', padding: 8 }} />
        </div>
        {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
        <button type="submit" disabled={loading} style={{ width: '100%', padding: 10, background: '#007AFF', color: '#fff', border: 'none', borderRadius: 4 }}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
}
